import { gql } from "graphql-request";

export const GET_ALL_PARTNERS = gql`
  query GetAllPartners(
    $pageNo: Int
    $pageSize: Int
    $searchKeyword: String
    $startDate: String
    $endDate: String
    $isRestricted: Boolean
    $tenantId: String
  ) {
    getAllPartners(
      pageNo: $pageNo
      pageSize: $pageSize
      searchKeyword: $searchKeyword
      startDate: $startDate
      endDate: $endDate
      isRestricted: $isRestricted
      tenantId: $tenantId
    ) {
      data {
        _id
        createdAt
        firstName
        lastName
        email
        isRestricted
        totalClients
        accessibleClients
        allowedPages
      }
      meta {
        countDocs
        pageNo
        pageSize
      }
    }
  }
`;

export const CREATE_PARTNERS = gql`
  mutation CreatePartner($partnerData: CreatePartnerInput!) {
    createPartner(partnerData: $partnerData) {
      data
    }
  }
`;

export const UPDATE_PARTNERS = gql`
  mutation UpdatePartnerInfo(
    $partnerData: UpdatePartnerInput!
    $partnerId: String!
  ) {
    updatePartnerInfo(partnerData: $partnerData, partnerId: $partnerId) {
      data
    }
  }
`;

export const DELETE_PARTNER = gql`
  mutation DeleteUserById($userId: String! ,$tenantId: String) {
    deleteUserById(userId: $userId,tenantId: $tenantId) {
      data
    }
  }
`;

export const UPDATE_PARTNER_STATUS = gql`
  mutation UpdateUserBlockStatus($email: String, $isRestricted: Boolean) {
    updateUserBlockStatus(email: $email, isRestricted: $isRestricted) {
      data
      meta {
        countDocs
        pageNo
        pageSize
      }
    }
  }
`;
